/**
 * Export Namespace
 */
export const SAILS_APP_NAME = 'GLASFASER_REGISTRATION';

import {dateFormat, email, maxLength, minLength, onlyNumbers, required, secureValue} from '@vfde-brix/core';
import { isResidentialOrBusinessUnitValid, validateRepresentedByInput } from 'Container/glasfaserRegistration/helpers/customInputValidator';

/**
 * Export REQUIRED_VALIDATION_CONFIG
 */
export const REQUIRED_VALIDATION_CONFIG = { validator: required, errorKey: 'required' };

/**
 * Export REQUIRED_CONFIRM_CHECKBOX_CONFIG
 */
export const REQUIRED_CONFIRM_CHECKBOX_CONFIG = { validator: required, errorKey: 'errorTextCheckbox' };

/**
 * Export ONLYNUMBERS_VALIDATION_CONFIG
 */
export const ONLYNUMBERS_VALIDATION_CONFIG = { validator: onlyNumbers, errorKey: 'onlyNumbers' };

/**
 * Export GENERAL_MAX_LENGTH_VALIDATION_CONFIG
 */
export const GENERAL_MAX_LENGTH_VALIDATION_CONFIG = { validator: maxLength, errorKey: 'generalMaxLength', maxLength: 150 };

/**
 * Export MIN_LENGTH_HOUSE_NUMBER_CONFIG
 */
export const MIN_LENGTH_HOUSE_NUMBER_CONFIG = { validator: minLength, errorKey: 'minLengthHouseNumber', minLength: 1 };

/**
 * Export MAX_LENGTH_HOUSE_NUMBER_CONFIG
 */
export const MAX_LENGTH_HOUSE_NUMBER_CONFIG = { validator: maxLength, errorKey: 'maxLengthHouseNumber', maxLength: 5 };

/**
 * Export MIN_LENGTH_ZIP_CODE_VALIDATION_CONFIG
 */
export const MIN_LENGTH_ZIP_CODE_VALIDATION_CONFIG = { validator: minLength, errorKey: 'minLengthZipcode', minLength: 4 };

/**
 * Export MAX_LENGTH_ZIP_CODE_VALIDATION_CONFIG
 */
export const MAX_LENGTH_ZIP_CODE_VALIDATION_CONFIG = { validator: maxLength, errorKey: 'maxLengthZipcode', maxLength: 5 };

/**
 * Export MIN_LENGTH_MOBILE_VALIDATION_CONFIG
 */
export const MIN_LENGTH_MOBILE_VALIDATION_CONFIG = { validator: minLength, errorKey: 'minLengthMobile', minLength: 6 };

/**
 * Export MAX_LENGTH_MOBILE_VALIDATION_CONFIG
 */
export const MAX_LENGTH_MOBILE_VALIDATION_CONFIG = { validator: maxLength, errorKey: 'maxLengthMobile', maxLength: 12 };

/**
 * Export MIN_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG
 */
export const MIN_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG = { validator: minLength, errorKey: 'minLengthPhoneNumber', minLength: 3 };

/**
 * Export MIN_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG
 */
export const MAX_LENGTH_PHONE_NUMBER_VALIDATION_CONFIG = { validator: maxLength, errorKey: 'maxLengthPhoneNumber', maxLength: 8 };

/**
 * Export MIN_LENGTH_PHONE_AREA_VALIDATION_CONFIG
 */
export const MIN_LENGTH_PHONE_AREA_VALIDATION_CONFIG = { validator: minLength, errorKey: 'minLengthPhoneAreaCode', minLength: 3 };

/**
 * Export MAX_LENGTH_PHONE_AREA_VALIDATION_CONFIG
 */
export const MAX_LENGTH_PHONE_AREA_VALIDATION_CONFIG = { validator: maxLength, errorKey: 'maxLengthPhoneAreaCode', maxLength: 5 };

/**
 * Export DATE_VALIDATION_CONFIG
 */
export const DATE_VALIDATION_CONFIG = { validator: dateFormat, errorKey: 'dateFormat' };

/**
 * Export EMAIL_VALIDATION_CONFIG
 */
export const EMAIL_VALIDATION_CONFIG = { validator: email, errorKey: 'email' };

/**
 * Export SECURE_VALUE_VALIDATION_CONFIG
 */
export const SECURE_VALUE_VALIDATION_CONFIG = { validator: secureValue, errorKey: 'secureValue' };

/**
 * Export RESIDENTIAL_OR_BUSINESS_UNIT_VALIDATION_CONFIG
 */
export const RESIDENTIAL_OR_BUSINESS_UNIT_VALIDATION_CONFIG = { validator: isResidentialOrBusinessUnitValid, errorKey: 'residenceOrBusinessUnitNumber' };

/**
 * Export REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG
 */
export const REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG = { validator: validateRepresentedByInput, errorKey: 'required' };

/**
 * Export REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG
 */
export const MAX_LENGTH_CITY_VALIDATION_CONFIG = { validator: maxLength, errorKey: 'maxLengthCity', maxLength: 30 };

/**
 * Export REPRESENTED_BY_REQUIRED_VALIDATION_CONFIG
 */
export const MAX_LENGTH_STREET_VALIDATION_CONFIG = { validator: maxLength, errorKey: 'maxLengthStreet', maxLength: 50 };

/**
 * Export JSON_HEADER
 */
export const JSON_HEADER = { 'Content-Type': 'application/json; charset=utf-8' };

/**
 * Site Structure coming from CMS (Nvaigation)
 */
export const ADDITIONAL_CMS_SITE_STRUCTURE = ['Privatkunden', 'Internet & Festnetz', 'Glasfaser', 'Contact'];

/**
 * Tracking Constant for logged in
 */
export const TRACKING_LOGGED_IN = 'logged in';
/**
 * Tracking Constant for not logged in
 * ToDo: Can this be handled in core?
 */
export const TRACKING_NOT_LOGGED_IN = 'not logged in';

/**
 * siteArea stands for product category
 */
export const TRACKING_SITE_AREA_MOBILITY = 'fiber';

/**
 * PageType
 */
export const TRACKING_PAGE_TYPE = 'lead';

/**
 * platformType
 */
export const TRACKING_PLATFORM_TYPE_RESPONSIVE = 'responsive';

/**
 * Tracking form name
 */
export const TRACKING_OFORM_NAME = 'glasfaser consumer form';

/**
 * Tracking form type
 */
export const TRACKING_OFORM_TYPE = 'lead';

/**
 * Tracking form step 1
 */
export const TRACKING_OFORM_FORMSTEP_ONE = '1';

/**
 * Tracking form step 2
 */
export const TRACKING_OFORM_FORMSTEP_TWO = '2';

/**
 * Tracking form step name
 */
export const TRACKING_OFORM_FORMSTEP_NAME = 'customer';

/**
 * Tracking form step name
 */
export const TRACKING_OFORM_FORMSTEP_NAME_SUCCESS = 'thank you';

/**
 * Tracking form status
 */
export const TRACKING_OFORM_FORM_STATUS_START = 'start';

/**
 * Tracking form success
 */
export const TRACKING_OFORM_FORM_STATUS_SUCCESS = ['end', 'success'];

/**
 * INPUT_FIRSTNAME_ID
 */
export const FORM_TYPE = 'consumer';

/**
 * INPUT_FIRSTNAME_ID
 */
export const INPUT_FIRSTNAME_ID = 'input-firstname';

/**
 * INPUT_LASTNAME_ID
 */
export const INPUT_LASTNAME_ID = 'input-lastname';

/**
 * INPUT_EMAIL_ID
 */
export const INPUT_EMAIL_ID = 'input-email';

/**
 * INPUT_PHONE_ID
 */
export const INPUT_PHONE_ID = 'input-phone';

/**
 * INPUT_COMPANY_ID
 */
export const INPUT_COMPANY_ID = 'input-company';

/**
 * INPUT_ZIPCODE_ID
 */
export const INPUT_ZIPCODE_ID = 'input-zipcode';

/**
 * INPUT_CITY_ID
 */
export const INPUT_CITY_ID = 'input-city';

/**
 * INPUT_STREET_ID
 */
export const INPUT_STREET_ID = 'input-street';

/**
 * INPUT_HOUSE_NUMBER_ID
 */
export const INPUT_HOUSE_NUMBER_ID = 'input-house-number';

/**
 * INPUT_HIDDEN_URL_LP
 */
 export const INPUT_HIDDEN_URL_LP = 'std_url';

/**
 * INPUT_HIDDEN_URL_LP
 */
  export const INPUT_HIDDEN_CONFIRMATION_EMAIL = 'confirmationEmail';

/**
 * CONTAINER FORM
 */
export const CONTAINER_FORM = 'container-registration-form';

/**
 * CONTAINER_FIRSTNAME
 */
export const CONTAINER_FIRSTNAME = 'container-firstname';

/**
 * CONTAINER_LASTNAME
 */
export const CONTAINER_LASTNAME = 'container-lastname';

/**
 * CONTAINER_EMAIL
 */
export const CONTAINER_EMAIL = 'container-email';

/**
 * CONTAINER_PHONE
 */
export const CONTAINER_PHONE = 'container-phone';

/**
 * CONTAINER_PHONE_AREA_CODE
 */
export const CONTAINER_PHONE_AREA_CODE = 'container-input-personal-phone-area';

/**
 * CONTAINER_PHONE_NUMBER
 */
export const CONTAINER_PHONE_NUMBER = 'container-input-personal-phone-number';

/**
 * CONTAINER_REPRESENTED_BY_PHONE_AREA_CODE
 */
 export const CONTAINER_REPRESENTED_BY_PHONE_AREA_CODE = 'container-input-represented-by-phone-area';

 /**
  * CONTAINER_REPRESENTED_BY_PHONE_NUMBER
  */
 export const CONTAINER_REPRESENTED_BY_PHONE_NUMBER = 'container-input-represented-by-phone-number';

/**
 * CONTAINER_COMPANY
 */
export const CONTAINER_COMPANY = 'container-company';

/**
 * CONTAINER_ZIPCODE
 */
export const CONTAINER_ZIPCODE = 'container-zipcode';

/**
 * CONTAINER_CITY
 */
export const CONTAINER_CITY = 'container-city';

/**
 * CONTAINER_STREET
 */
export const CONTAINER_STREET = 'container-street';

/**
 * CONTAINER_HOUSE_NUMBER
 */
export const CONTAINER_HOUSE_NUMBER = 'container-house-number';

/**
 * CONTAINER SUBMIT BUTTON
 */
export const CONTAINER_SUBMIT = 'container-submit';

/**
 * CONTAINER LOADING-SPINNER
 */
export const LOADING_INDICATOR_CONTAINER = 'brix-loading-spinner-container';

/**
 * CONTAINER LOADING-SPINNER
 */
export const CONTAINER_NOTIFICATION_SUCCESS = 'container-notification-success';

/**
 * CONTAINER LOADING-SPINNER
 */
export const CONTAINER_NOTIFICATION_FAILED = 'container-notification-failed';

/**
 * CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE
 */
export const CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE = 'container-service-not-available';

/**
 * Service of Registration is not available
 */
export const GLASFASER_SERVICE_NOT_AVAILABLE = 'Deine Registrierung hat nicht geklappt!';

/**
 * CONTAINER REGISTRATION FAILED
 */
export const CONTAINER_REGISTRATION_FAILED = 'container-notification-service-not-available';

/**
 * CONTAINER REGISTRATION SUCCEED
 */
export const CONTAINER_REGISTRATION_SUCCEED = 'registration-succeed';

/**
 * CONTAINER REGISTRATION SUCCEED
 */
 export const CONTAINER_REGISTRATION_TRY_AGAIN = 'registration-failed';

/**
 * CONTAINER REGISTRATION SUCCEED
 */
export const CONTAINER_SCROLL_INTO = 'text-only-834928';

/**
 * CONTAINER INPUT SELECTION SEX
 */
export const CONTAINER_INPUT_SELECTION_SEX = 'container-input-selection-control-sex';

/**
 * CONTAINER INPUT FIRSTNAME
 */
export const CONTAINER_INPUT_FIRSTNAME = 'container-input-firstname';

/**
 * CONTAINER INPUT LANSTNAME
 */
 export const CONTAINER_INPUT_LANSTNAME = 'container-input-lastname';

/**
 * CONTAINER INPUT COMPANY
 */
export const CONTAINER_INPUT_COMPANY = 'container-input-company';

/**
 * CONTAINER INPUT PERSONAL STREET
 */
 export const CONTAINER_INPUT_PERSONAL_STREET = 'container-input-personal-street';

/**
 * CONTAINER INPUT PERSONAL HOUSE_NUMBER
 */
 export const CONTAINER_INPUT_PERSONAL_HOUSE_NUMBER = 'container-input-personal-house-number';

/**
 * CONTAINER INPUT PERSONAL ZIPCODE
 */
 export const CONTAINER_INPUT_PERSONAL_ZIPCODE = 'container-input-personal-zipcode';

/**
 * CONTAINER INPUT PERSONAL CITY
 */
 export const CONTAINER_INPUT_PERSONAL_CITY = 'container-input-personal-city';

/**
 * CONTAINER INPUT PERSONAL COUNTRY
 */
 export const CONTAINER_INPUT_PERSONAL_COUNTRY = 'container-input-personal-country';

/**
 * CONTAINER INPUT PERSONAL BIRTHDAY
 */
 export const CONTAINER_INPUT_PERSONAL_BIRTHDAY = 'container-input-personal-birthday';

/**
 * CONTAINER INPUT EMAIL
 */
 export const CONTAINER_INPUT_EMAIL = 'container-input-email';

/**
 * CONTAINER INPUT MOBILE
 */
 export const CONTAINER_INPUT_MOBILE = 'container-input-mobile';

/**
 * CONTAINER INPUT REPRESENTED BY
 */
 export const CONTAINER_INPUT_REPRESENTED_BY = 'container-input-represented-by';

/**
 * CONTAINER INPUT REPRESENTED BY FIRSTNAME
 */
  export const CONTAINER_INPUT_REPRESENTED_BY_FIRSTNAME = 'container-input-represented-by-firstname';

/**
 * CONTAINER INPUT REPRESENTED BY LASTNAME
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_LASTNAME = 'container-input-represented-by-lastname';

/**
 * CONTAINER INPUT REPRESENTED BY COMPANY
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_COMPANY = 'container-input-represented-by-company';

/**
 * CONTAINER INPUT REPRESENTED BY STREET
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_STREET = 'container-input-represented-by-street';

/**
 * CONTAINER INPUT REPRESENTED BY HOUSE_NUMBER
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_HOUSE_NUMBER = 'container-input-represented-by-house-number';

/**
 * CONTAINER INPUT REPRESENTED BY ZIPCODE
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_ZIPCODE = 'container-input-represented-by-zipcode';

/**
 * CONTAINER INPUT REPRESENTED BY EMAIL
 */
export const CONTAINER_INPUT_REPRESENTED_BY_EMAIL = 'container-input-represented-by-email';

/**
 * CONTAINER INPUT REPRESENTED BY MOBILE
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_MOBILE = 'container-input-represented-by-mobile';

/**
 * CONTAINER INPUT REPRESENTED BY CITY
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_CITY = 'container-input-represented-by-city';

/**
 * CONTAINER INPUT REPRESENTED BY COUNTRY
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_COUNTRY = 'container-input-represented-by-country';

/**
 * CONTAINER INPUT REPRESENTED BY BIRTHDAY
 */
 export const CONTAINER_INPUT_REPRESENTED_BY_BIRTHDAY = 'container-input-represented-by-birthday';

/**
 * CONTAINER INPUT STREET
 */
 export const CONTAINER_INPUT_STREET = 'container-input-street';

/**
 * CONTAINER INPUT HOUSE_NUMBER
 */
 export const CONTAINER_INPUT_HOUSE_NUMBER = 'container-input-house-number';

/**
 * CONTAINER INPUT ZIPCODE
 */
 export const CONTAINER_INPUT_ZIPCODE = 'container-input-zipcode';

/**
 * CONTAINER INPUT CITY
 */
 export const CONTAINER_INPUT_CITY = 'container-input-city';

/**
 * CONTAINER INPUT FLOORNUMBER
 */
 export const CONTAINER_INPUT_FLOORNUMBER = 'container-input-floornumber';

/**
 * CONTAINER INPUT DISTRICT
 */
export const CONTAINER_INPUT_DISTRICT = 'container-input-district';

/**
 * CONTAINER INPUT NUMBER_OF_RESIDENCE
 */
 export const CONTAINER_INPUT_NUMBER_OF_RESIDENCE = 'container-input-number-of-residence';

/**
 * CONTAINER INPUT NUMBER_OF_BUSINESS_UNIT
 */
 export const CONTAINER_INPUT_NUMBER_OF_BUSINESS_UNIT = 'container-input-number-of-business-unit';

/**
 * CONTAINER INPUT CONFIRMATION
 */
 export const CONTAINER_INPUT_CONFIRMATION = 'container-input-confirmation';

/**
 * CONTAINER INPUT SUBMIT
 */
export const CONTAINER_INPUT_SUBMIT = 'container-input-submit';

/**
 * Type of the notification that needs to be mounted
 */
 export enum NotificationType {
    INFO = 'info',
    ERROR = 'error',
    SUCCESS = 'success',
}
